import { normalizeShareCode } from "@roxpacer/core";
import { useSyncExternalStore } from "react";

export type Route =
  | { name: "planner" }
  | { name: "race-card" }
  | { name: "shared"; code: string }
  | { name: "shared-race-card"; code: string }
  | { name: "not-found" };

const NAVIGATE_EVENT = "roxpacer:navigate";

export function parseRoute(pathname: string): Route {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/" || path === "/auth/callback") return { name: "planner" };
  if (path === "/race-card") return { name: "race-card" };
  const shared = /^\/s\/([^/]+)(\/race-card)?$/.exec(path);
  if (shared) {
    const code = normalizeShareCode(decodeURIComponent(shared[1]!));
    if (!code) return { name: "not-found" };
    return shared[2] ? { name: "shared-race-card", code } : { name: "shared", code };
  }
  return { name: "not-found" };
}

/** Changes the URL without a page load and re-renders routed views. */
export function navigate(path: string, options: { replace?: boolean } = {}): void {
  if (options.replace) window.history.replaceState(null, "", path);
  else window.history.pushState(null, "", path);
  window.dispatchEvent(new Event(NAVIGATE_EVENT));
  if (!options.replace) window.scrollTo(0, 0);
}

function subscribe(onChange: () => void) {
  window.addEventListener("popstate", onChange);
  window.addEventListener(NAVIGATE_EVENT, onChange);
  return () => {
    window.removeEventListener("popstate", onChange);
    window.removeEventListener(NAVIGATE_EVENT, onChange);
  };
}

export function usePathname(): string {
  return useSyncExternalStore(subscribe, () => window.location.pathname);
}

export function sharePath(code: string, raceCard = false): string {
  return `/s/${code}${raceCard ? "/race-card" : ""}`;
}
